import { Card } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { HeadingSecondary } from "../typography/headingSecondary/HeadingSecondary";
import { ComponentWithChildren } from "../../../../common/types";
import colors from "../../../../common/styles/colors";

const useStyles = makeStyles({
  card: (props: Props) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "706px",
    minHeight: "582px",
    padding: "12px 0",
    borderRadius: "16px",
    boxShadow: "none",
    position: "relative",
    justifyContent: "center",
    borderColor: props.isScanSuccess ? colors.lightGreenColor : "transparent",
    ["@media (max-width:706px)"]: {
      width: "100%"
    },
    ["@media (max-height:600px)"]: {
      marginBottom: "60px"
    }
  })
});

type Props = {
  headingText?: string;
  isScanSuccess?: boolean;
};

export const FreyaCard: ComponentWithChildren<Props> = ({ children, headingText, isScanSuccess }) => {
  const classes = useStyles({ isScanSuccess });

  return (
    <Card className={classes.card} data-testid="freya-card">
      {headingText && <HeadingSecondary>{headingText}</HeadingSecondary>}
      {children}
    </Card>
  );
};
